<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>考点资料</el-breadcrumb-item>
        <el-breadcrumb-item>免费资料</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>免费资料</span>
        </div>
      </div>
      <div class="xcx-content flex" v-loading="loading">
        <div class="flex-grow bg-w mr20">
          <div class="pt20 pb20">
            <el-empty :image-size="200" v-if="tableData.length == 0"></el-empty>
            <div v-else>
              <div class="x">
                <div class="bg-F9F9F9 flex space alcenter box-border pl10 pr10 mb10" v-for="(v, i) in tableData" :key="i">
                  <div class="flex-grow flex text-6F8199 ft16 text-over">

                    <el-tag v-if="v.type == 0" type="danger">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 1" type="success">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 2">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 3" type="warning">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 4" type="danger">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 5" type="warning">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 6" type="success">{{ v.type_name }}</el-tag>
                    <el-tag v-else-if="v.type == 7">{{ v.type_name }}</el-tag>

                    <div class="truncate" :title="v.title">{{ v.title }}</div>
                  </div>
                  <div class="flex-shrink-0 text-6F8199 ft14 ml30">下载时间：{{ v.created_at }}
                  </div>
                  <div class="flex-shrink-0 ml30">
                    <el-button type="primary" @click="downLoadFile(v)" icon="el-icon-download">下载资料</el-button>
                  </div>
                </div>
              </div>
              <!--分页-->
              <div class="paging">
                <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="total, prev, pager, next" :total="count" :page-size="limit"></el-pagination>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
  <script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      page: 0,
      count: 0,
      limit: 8,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    downLoadFile(v) {
      let that = this;
      that.axios.post("/getFreeDownloadUrl", { id: v.id }).then((res) => {
        if (res.code == 200) {
          window.open(res.data.urls);
        } else {
          that.$message({
            type: "error",
            message: `操作提示: ${res.msg}`,
          });
          return;
        }
      });
    },

    downLoadFiles(v) {
      let that = this;
      that.axios.post("/getDownloadUrl", { id: v.id }).then((res) => {
        if (res.code == 200) {
          window.open(res.data.urls);
        } else {
          that.$message({
            type: "error",
            message: `操作提示: ${res.msg}`,
          });
          return;
        }
      });
    },

    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.column_id = that.column_id;
      formData.limit = that.limit;
      that.axios.post("/getFreeDownload", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
  <style>
.xcx-head {
  margin-bottom: 0px;
}

.flex-grow {
  flex-grow: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.inline-block {
  display: inline-block;
}

.thumb_images {
  width: 100%;
  height: 175px;
  border-radius: 5px;
}

.border-tags {
  border: 1px solid #c18958;
}

.text-tags {
  color: #c18958;
}

.text-6581A0 {
  color: #6581a0;
}

.bg-F9F9F9 {
  background: #f9f9f9;
  height: 60px;
}

.text-6F8199 {
  color: #6f8199;
  align-items: center;
}

.border-sub {
  border: 1px solid #cccccc;
}

.year-tag {
  background-color: #f0f3f7;
  color: #233650;
  width: 106px;
  height: 42px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
}

.year-tag.active {
  background-color: #3078ff;
  color: #fff;
  position: relative;
}

.year-tag.active::after {
  content: "";
  display: block;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 8px solid #3078ff;
  position: absolute;
  bottom: -8px;
  left: 50%;
  margin-left: -7px;
}

.truncate {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>